import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import empty from "../../assets/nothing.svg";
import styles from './styles.module.scss';


const EmptyView = ({
                     icon,
                     message,
                     customContainerClassName
                   }) => {

  return (
    <div className={classnames(styles.emptyContainer, customContainerClassName)}>
      <img
        src={icon ? icon : empty}
        alt="empty"
        className={styles.emptyIcon}
      />
      <div className={styles.emptyMessage}>
        {message}
      </div>
    </div>
  )
};

EmptyView.propTypes = {
  icon: PropTypes.string,
  message: PropTypes.string
};

export default EmptyView;
